<template lang="pug">
#laudos
    SelecionarTerritorio(
        :tipoLaudo='tipoLaudo',
        @getTerritoriosSelecionados='solicitarLaudos',
        @cancelar-modal='changeShowModalSelecionarTerritorio',
        ref='selecionarTerritorio'
    )
</template>

<script>
import SelecionarTerritorio from '@/components/laudos/SelecionarTerritorio.vue';
import TipoLaudo from '@/constants/TipoLaudo';
import LaudoService from '@/services/LaudosService';
import { mapGetters, mapState } from 'vuex';

export default {
    name: 'Laudos',
    components: {
        SelecionarTerritorio
    },
    computed: {
        ...mapGetters(['usuarioLogado']),
        ...mapState(['usuarioIsLaudo'])
    },
    data() {
        return {
            tipoLaudo: TipoLaudo.AVALIACAO_DE_AREA_PRODUTIVA,
            showModalVisualizacao: false,
            showModalSelecionarTerritorios: false,
            showModalConfirmarTerritorios: false,
            territoriosSelecionados: [],
            pageParams: {
                page: 1,
                size: 20,
                sort: 'dataCadastro,DESC'
            },
            filtros: {
                dataCadastroFim: '',
                dataCadastroInicio: '',
                dataFinalizacaoFim: '',
                dataFinalizacaoInicio: '',
                representantesCpfCnpj: [],
                situacaoId: '',
                statusId: '',
                territoriosIds: [],
                tipoLaudoId: TipoLaudo.AVALIACAO_DE_AREA_PRODUTIVA
            },
            totalLaudos: 0,
            laudos: [],
            idLaudo: null,
            rowInfo: null,
            showModalInsercaoResultados: false,
            usuariosBuffer: {},
            loading: false,
            isLaudoUnico: false
        };
    },
    methods: {
        async getLaudos() {
            if (this.usuarioIsLaudo) {
                this.$router.push({ name: 'LaudoAvaliacaoSocioambiental' });
            }
            await this.requestLaudos();
        },

        changeShowModalSelecionarTerritorio() {
            this.showModalSelecionarTerritorios =
                !this.showModalSelecionarTerritorios;
            this.$emit('showModalSelecionarTerritorios');
        },

        changeShowModalConfirmarTerritorios() {
            this.showModalConfirmarTerritorios =
                !this.showModalConfirmarTerritorios;
        },

        solicitarLaudos(territoriosSelecionados) {
            this.changeShowModalSelecionarTerritorio();
            this.changeShowModalConfirmarTerritorios();
            this.territoriosSelecionados = territoriosSelecionados;
            this.$emit(
                'atualizarTerritoriosSelecionados',
                this.territoriosSelecionados
            );
        },

        voltar() {
            this.changeShowModalConfirmarTerritorios();
            this.getLaudos();
        },
        handleModalLaudo(laudo) {
            this.showModalVisualizacao = !this.showModalVisualizacao;
            this.idLaudo = laudo;
        },
        handleSort(paramsProp) {
            this.pageParams = {
                page: this.pageParams.page,
                size: 20,
                sort: `${paramsProp.column},${paramsProp.order}`
            };
            this.getLaudos();
        },
        handleModalInsercaoResultados(rowInfo) {
            this.rowInfo = rowInfo;
            this.showModalInsercaoResultados =
                !this.showModalInsercaoResultados;
        },
        filtrar(filtros) {
            this.filtros = { ...filtros };
            this.getLaudos();
        },

        async requestLaudos() {
            try {
                this.loading = true;
                const { data } = await LaudoService.requestLaudos(
                    this.filtros,
                    this.pageParams
                );
                this.totalLaudos = data.totalItens;
                this.laudos = data.laudos;
            } catch (error) {
                this.$notify.error({
                    message: this.$t(
                        'mensagens.laudos.erro.naoFoiPossivelCarregarOsDados'
                    )
                });
            } finally {
                this.loading = false;
            }
        },

        atualizaLaudoUnico(laudoUnico) {
            this.isLaudoUnico = laudoUnico === 'true';
        }
    }
};
</script>

<style scoped lang="scss">
#laudos {
    .laudo-margin {
        margin-bottom: 20px;
    }

    header {
        display: flex;
        align-items: center;
        justify-content: space-between;
    }
}
</style>
